// Chiamate HTTP del workspace: la sessione viaggia nel cookie httpOnly, nessun token nel browser.
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function api(path, opts = {}) {
  const response = await fetch(`${API}${path}`, { credentials: "include", headers: { "Content-Type": "application/json", ...(opts.headers || {}) }, ...opts });
  const text = await response.text();
  const json = text ? JSON.parse(text) : null;
  if (!response.ok) throw new Error(json?.detail || "Errore di rete");
  return json;
}

export async function apiUpload(path, formData) {
  const response = await fetch(`${API}${path}`, { method: "POST", credentials: "include", body: formData });
  const text = await response.text();
  const json = text ? JSON.parse(text) : null;
  if (!response.ok) throw new Error(json?.detail || "Upload fallito");
  return json;
}

export async function apiBlob(path) {
  const response = await fetch(`${API}${path}`, { credentials: "include" });
  if (!response.ok) {
    let detail = "";
    try {
      const payload = await response.json();
      detail = typeof payload?.detail === "string" ? payload.detail
        : Array.isArray(payload?.detail) ? payload.detail.map(d => d.msg).filter(Boolean).join(", ") : "";
    } catch { detail = ""; }
    throw new Error(detail || "Download fallito");
  }
  return await response.blob();
}

export async function downloadFile(path, filename) {
  const blob = await apiBlob(path);
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url; link.download = filename; link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
